import { isProviderACompany } from "../../../services/Provider/Provider.service";
import useUser from "../UserProvider/useUser";
import { withGuard } from "./GenericRouteGuard";

export function withCompanyRouteGuard(WrappedComponent) {
  return function FeatureGuardWrapper(props) {
    const { user } = useUser();
    return withGuard(WrappedComponent, isProviderACompany(user.provider) )(props)
  };
}